module.exports = {
  test: {
    title: 'This page can be deleted in the actual development, this example is used to manage page status using vuex demo',
    currentcode: 'Current Code',
    precode: 'Previous Code',
    changecode: 'Change Code',
    simplealert: 'Simple Alert',
    alerttitle: 'Alert Title',
    ok: 'OK',
    close: 'Close',
    welcome: 'Welcome to VBP'
  }
}



// WEBPACK FOOTER //
// ./src/languages/en.js